module.exports = __webpack_public_path__ + "static/Download_on_the_App_Store_Badge_IT_RGB_blk_100317-0a6a96b9e3294e2e3b62f5bbd8f16f22.svg";